import store from "store";
import { ICommentItem } from "@/types/post";
import eventEmitter from "@/utils/eventEmitter";
import xlClientMixin from "@/mixins/pc-client";
import ssoMixin from "@/mixins/sso";
import { detectOS, checkIOS } from "@/utils/util";

export default {
  mixins: [xlClientMixin, ssoMixin],
  data() {
    return {
      checkRestoreId: "",
    };
  },
  computed: {
    curUser() {
      return this.$store.state.user.curUser;
    },
    hasLogin() {
      return this.curUser.userId !== "0";
    },
    isIOS() {
      return process.client ? checkIOS() : false;
    },
    needPhoneAuth() {
      return this.$store.state.user.needPhoneAuth;
    },
  },
  methods: {
    stat(action: string, data: any): void {
      this.$stat("xiaozhan", action, data);
    },
    async handleLike(item: ICommentItem, level: string, isLiked: boolean) {
      this.stat("xiaozhan_comment_section_good_click", {
        button: isLiked ? "no-good" : "good",
      });

      if (!this.hasLogin) {
        this.popLogin("comment");
        return;
      }

      if (this.needPhoneAuth) {
        try {
          const result = await this.$phoneAuth.showDialog({
            "auth.userid": this.curUser.userId,
            from: "good",
          });

          if (result === "confirm") {
            this.$store.commit("user/SET_NEED_PHONE_AUTH", false);
          } else {
            return;
          }
        } catch (e) {
          return;
        }
      }

      const actionName = isLiked
        ? "post/unlikeFeedComment"
        : "post/likeFeedComment";

      try {
        await this.$store.dispatch(actionName, {
          comment_id: item.comment_id,
          tid: this.tid,
          level,
          cid: this.info.origin_cid,
        });
        return "ok";
      } catch (e) {
        this.$message({
          type: "warning",
          message: e.message || "操作失败",
        });
        return "error";
      }
    },
    handleDelete(item: ICommentItem, level: string) {
      console.log("handleDelete");
      if (!this.hasLogin) {
        this.popLogin("comment");
        return;
      }

      this.stat("xiaozhan_comment_section_delete_click", {});

      eventEmitter.emit("comment-delete", 0, { item, level });
    },
    handleReport() {
      this.stat("xiaozhan_comment_section_report_click", {});
      // TODO: 举报结果
      // this.stat("xiaozhan_comment_section_report_result", {
      //   result: "success"
      // });
    },
    confirmReply(data: any) {
      if (!this.hasLogin) {
        this.popLogin("comment");
        return;
      }
    },
  },
};
